/* MONOGEMS CUSTOM JS */

document.addEventListener('DOMContentLoaded', function () {
  initFlashSaleCountdown();
  initSplashImage();
  initFooterAccordions();
  initStickyATC();
  initProductGallery();
  initConfiguratorPopupGuard();
});


/* ---------------------------------------------
   Flash Sale Countdown
--------------------------------------------- */

function initFlashSaleCountdown() {
  var totalMs = 548 * 60 * 1000;
  var key = 'flashSaleEnd';

  var daysEl = document.getElementById('days');
  var hoursEl = document.getElementById('hours');
  var minutesEl = document.getElementById('minutes');
  var secondsEl = document.getElementById('seconds');

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

  var end = parseInt(localStorage.getItem(key), 10);

  if (!end || end <= Date.now()) {
    end = Date.now() + totalMs;
    localStorage.setItem(key, String(end));
  }

  function update() {
    var diff = end - Date.now();

    if (diff <= 0) {
      end = Date.now() + totalMs;
      localStorage.setItem(key, String(end));
      diff = totalMs;
    }

    daysEl.textContent = String(Math.floor(diff / 86400000)).padStart(2, '0');
    hoursEl.textContent = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
    minutesEl.textContent = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
    secondsEl.textContent = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
  }

  update();
  setInterval(update, 1000);
}


/* ---------------------------------------------
   Random Splash Image
--------------------------------------------- */

function initSplashImage() {
  var el = document.querySelector('[data-splash]');
  if (!el) return;

  var sets = [
    {
      d: "url('https://cdn.shopify.com/s/files/1/0842/2899/7448/files/homehero_D2.jpg?v=1778765879')",
      m: "url('https://cdn.shopify.com/s/files/1/0842/2899/7448/files/homehero_M2.jpg?v=1778765879')"
    },
    {
      d: "url('https://cdn.shopify.com/s/files/1/0842/2899/7448/files/homehero_D3.jpg?v=1778772355')",
      m: "url('https://cdn.shopify.com/s/files/1/0842/2899/7448/files/homehero_M3.jpg?v=1778772355')"
    }
  ];

  var choice = sets[Math.floor(Math.random() * sets.length)];

  el.style.setProperty('--splash-desktop', choice.d);
  el.style.setProperty('--splash-mobile', choice.m);
}


/* ---------------------------------------------
   Mobile Footer Accordions
--------------------------------------------- */

function initFooterAccordions() {
  var TARGETS = ['OUR PROMISES', 'Customer Care'];
  var hasRun = false;

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function openFooterAccordionByLabel(footer, label) {
    var wanted = normalize(label);

    var details = Array.from(footer.querySelectorAll('details')).find(function (detail) {
      var summary = detail.querySelector('summary');
      return summary && normalize(summary.textContent) === wanted;
    });

    if (details) {
      details.open = true;
      return true;
    }

    var button = Array.from(footer.querySelectorAll('button')).find(function (btn) {
      var form = btn.closest('form');

      if (form && form.action && form.action.includes('localization')) {
        return false;
      }

      return normalize(btn.textContent) === wanted;
    });

    if (!button) return false;

    if (button.getAttribute('aria-expanded') === 'true') return true;

    button.click();
    return true;
  }

  function run() {
    if (hasRun) return;

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (!isMobile) return;

    var footer = document.querySelector('footer');
    if (!footer) return;

    TARGETS.forEach(function (label) {
      openFooterAccordionByLabel(footer, label);
    });

    hasRun = true;
  }

  run();

  setTimeout(run, 250);
  setTimeout(run, 1000);
}


/* ---------------------------------------------
   Sticky Add To Cart, Product Page Mobile
--------------------------------------------- */

function initStickyATC() {
  var form = document.querySelector('form.product-single__form[action="/cart/add"]');
  if (!form) return;

  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var threshold = 20;

  var placeholder = document.createElement('div');
  placeholder.className = 'sticky-atc-placeholder';
  placeholder.setAttribute('aria-hidden', 'true');
  placeholder.style.display = 'none';

  form.parentNode.insertBefore(placeholder, form.nextSibling);

  var shouldBeVisible = false;
  var ticking = false;

  function getOriginalBottom() {
    var ref = placeholder.style.display === 'none' ? form : placeholder;
    return ref.getBoundingClientRect().top + window.scrollY + ref.offsetHeight;
  }

  function updatePlaceholderHeight() {
    placeholder.style.height = form.offsetHeight + 'px';
  }

  function show() {
    if (shouldBeVisible) return;

    shouldBeVisible = true;

    if (!form.classList.contains('sticky-atc')) {
      updatePlaceholderHeight();
      placeholder.style.display = 'block';
      form.classList.add('sticky-atc');

      void form.offsetWidth;
    }

    form.classList.add('sticky-atc-visible');
  }

  function hide() {
    if (!shouldBeVisible) return;

    shouldBeVisible = false;
    form.classList.remove('sticky-atc-visible');
  }

  function resetSticky() {
    shouldBeVisible = false;
    form.classList.remove('sticky-atc', 'sticky-atc-visible');
    placeholder.style.display = 'none';
    placeholder.style.height = '';
  }

  form.addEventListener('transitionend', function (event) {
    if (event.propertyName !== 'transform') return;

    if (!shouldBeVisible && form.classList.contains('sticky-atc')) {
      form.classList.remove('sticky-atc');
      placeholder.style.display = 'none';
      placeholder.style.height = '';
    }
  });

  function toggleStickyATC() {
    if (!mobileQuery.matches) {
      resetSticky();
      return;
    }

    var scrolledPastForm = window.scrollY >= getOriginalBottom() + threshold;

    if (scrolledPastForm) {
      show();
    } else {
      hide();
    }
  }

  function onScrollOrResize() {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(function () {
      toggleStickyATC();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', toggleStickyATC);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(toggleStickyATC);
  }

  toggleStickyATC();
}

/* ---------------------------------------------
   Product Gallery Fix (Motion theme.js incompatibility)
--------------------------------------------- */

function initProductGallery() {
  var galleries = document.querySelectorAll('[data-product-photos]');
  if (!galleries.length) return;

  galleries.forEach(function (gallery) {
    if (gallery.dataset.galleryInit === '1') return;
    gallery.dataset.galleryInit = '1';

    var slides = gallery.querySelectorAll('.product-main-slide');
    if (!slides.length) return;

    var section = gallery.closest('.product-section') || gallery.parentNode;
    var thumbsRoot = section.querySelector('[data-product-thumbs]');

    var currentIndex = 0;
    var totalSlides = slides.length;

    function showSlide(index) {
      index = parseInt(index, 10);
      if (isNaN(index) || index < 0 || index >= totalSlides) return;

      currentIndex = index;

      slides.forEach(function (slide) {
        var slideIdx = parseInt(slide.getAttribute('data-index'), 10);
        var match = slideIdx === index;

        slide.style.display = match ? 'block' : 'none';
        slide.classList.toggle('is-active', match);
      });

      if (thumbsRoot) {
        var thumbs = thumbsRoot.querySelectorAll('.product__thumb');
        thumbs.forEach(function (thumb) {
          var thumbIdx = parseInt(thumb.getAttribute('data-index'), 10);
          thumb.classList.toggle('is-active', thumbIdx === index);
        });

        var activeThumbItem = thumbsRoot.querySelector('.product__thumb-item[data-index="' + index + '"]');
        if (activeThumbItem && activeThumbItem.scrollIntoView) {
          activeThumbItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }

    function nextSlide() {
      var nextIdx = (currentIndex + 1) % totalSlides;
      showSlide(nextIdx);
    }

    function prevSlide() {
      var prevIdx = (currentIndex - 1 + totalSlides) % totalSlides;
      showSlide(prevIdx);
    }

    showSlide(0);

    if (thumbsRoot) {
      thumbsRoot.addEventListener('click', function (e) {
        var thumb = e.target.closest('.product__thumb');
        if (!thumb || !thumbsRoot.contains(thumb)) return;

        e.preventDefault();
        e.stopPropagation();

        var idx = thumb.getAttribute('data-index');
        if (idx === null) return;

        showSlide(idx);
      });
    }

    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;
    var touchActive = false;
    var swipeThreshold = 40;

    gallery.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchEndX = touchStartX;
      touchEndY = touchStartY;
      touchActive = true;
    }, { passive: true });

    gallery.addEventListener('touchmove', function (e) {
      if (!touchActive || e.touches.length !== 1) return;
      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;
    }, { passive: true });

    gallery.addEventListener('touchend', function (e) {
      if (!touchActive) return;
      touchActive = false;

      var deltaX = touchEndX - touchStartX;
      var deltaY = touchEndY - touchStartY;

      if (Math.abs(deltaX) < swipeThreshold) return;
      if (Math.abs(deltaY) > Math.abs(deltaX)) return;

      if (deltaX < 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prevSlide();
      }
    });

    gallery.setAttribute('tabindex', '0');
  });
}

/* ---------------------------------------------
   Configurator / Klaviyo Popup Guard
--------------------------------------------- */

function initConfiguratorPopupGuard() {
  window.addEventListener('monogems:open-configurator', function () {
    document.body.classList.add('mg-configurator-open');
  });

  window.addEventListener('monogems:popup-closed', function () {
    document.body.classList.remove('mg-configurator-open');
  });
}